import { useJsApiLoader } from '@react-google-maps/api';
import config from '../configs/config';

const { googleMapSettings } = config;

export default function useGoogleMapsLoader() {
  return useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapSettings.apiKey
  });
}
